import type { ReactNode } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";

export type EventStatField = {
  label: string;
  value: ReactNode;
  onClick?: () => void;
};

type EventStatsMobileGridProps = {
  fields: EventStatField[];
};

export function EventStatsMobileGrid({ fields }: EventStatsMobileGridProps) {
  return (
    <Paper variant="outlined" sx={{ width: "100%", p: 1.5 }}>
      <Grid container spacing={1.5}>
        {fields.map((field) => (
          <Grid key={field.label} size={{ xs: 6 }}>
            <Box
              onClick={field.onClick}
              sx={{
                border: 1,
                borderColor: "divider",
                borderRadius: 1,
                p: 1.5,
                height: "100%",
                cursor: field.onClick ? "pointer" : "default",
                ...(field.onClick && {
                  "&:hover": { bgcolor: "action.hover" },
                }),
              }}
            >
              <Typography variant="caption" color="text.secondary" display="block">
                {field.label}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  mt: 0.25,
                  wordBreak: "break-word",
                  ...(field.onClick && { textDecoration: "underline" }),
                }}
              >
                {field.value}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
